import React, {Component} from 'react'
import {connect} from 'react-redux'
import Security from "../../components/security";
import {
  getAppSetting,
  updateAccountLockoutSettings,
  updateFileUploadSettings
} from "../../redux/actions/appSettingActions";

class SecurityPage extends Component {

  render() {

    const {
      translate,
      updateFileUploadSettings,
      getAppSetting,
      updateAccountLockoutSettings,
      fileUploadSettings,
      accountLockoutSettings,
      log
    } = this.props

    return (
      <Security translate={translate}
                fileUploadSettings={fileUploadSettings}
                updateFileUploadSettings={updateFileUploadSettings}
                getAppSetting={getAppSetting}
                accountLockoutSettings={accountLockoutSettings}
                updateAccountLockoutSettings={updateAccountLockoutSettings}
                log={log}
      />
    )
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  updateFileUploadSettings: (data) => dispatch(updateFileUploadSettings(data)),
  getAppSetting: (options) => dispatch(getAppSetting(options)),
  updateAccountLockoutSettings: (data) => dispatch(updateAccountLockoutSettings(data)),
})

const mapStateToProps = (state) => ({
  log: state.settingReducer.log,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
  accountLockoutSettings: state.appSettingReducer.accountLockoutSettings,
})

export default connect(mapStateToProps, mapDispatchToProps)(SecurityPage)
